export const MISSED_INTENTS_ANALYSIS = {
    id: "missedIntentsAnalysis",
    title: "Intents Analysis",
    columns: {

    }
};
export const MISSED_INTENTS_RESPONSES = {
    id: "missedIntentsResponses",
    title: "Missed Intents Responses",
    columns: {
        "Prompt Name": "Name of the prompt sent by the Intelligent Assistant that the user response is associated with",
        "Prompt Text": "Message from the Intelligent Assistant that the user response is associated with.",
        "Dialog Group": "Group to which the prompt has been assigned",
        "User Response": "User input value associated with the corresponding Intelligent Assistant prompt",
        "Missed Intent Count": "Number of times this prompt/response combination appears and does not get classified",
        "Average Confidence": "The average confidence this prompt/response combination had",
        "Channel": "The channel from which the user input was received",
        "ASR Engine": "Speech recognition engine used to transcribe user responses",
        "Language": "Language the prompt was given in"
    }
};
export const NLU_MESSAGES = { id: "nluMessages", title: "NLU Messages" };
export const PROMPT_RESPONSES = {
    id: "promptResponses",
    title: "Caller Utterance Report - NLU",
    columns: {
        "Prompt Name": "Name of the prompt sent by the Intelligent Assistant that the user response is associated with",
        "Dialog Group": "Group to which the prompt has been assigned",
        "Prompt Text": "Message from the Intelligent Assistant that the user response is associated with.",
        "User Response": "User input value associated with the corresponding Intelligent Assistant prompt",
        "Intent": "User's intent predicted by Intelligent Assistant if a prediction was generated",
        "Valid Response": "True/False value indicating whether the user input matched a trained Intent or user input resulted in a valid speech recognition grammar result",
        "Raw text": "Initial response transcribed by ASR engine before interpretation",
        "Error": "Type of error that occurred. Value is blank if valid",
        "Language": "Language the prompt was given in",
        "Intent Confidence": "How confident the Intelligent Assistant was in regards to matching the user input to a trained Intent",
        "ASR Confidence": "How confident the Intelligent Assistant was in regards to transcribing the user's audio input (audio channels only)",
        "Channel": "The channel from which the user input was received",
        "Conversation Id": "Id referencing full conversation",
        "Timestamp": "Time prompt occurred",
        "Input Mode": "Type of user response",
        "Audio": "Redacted recording of user response if it exists",
        "Unredacted Audio URL": "URL for the non-redacted recording version of the users response",
        "Unredacted MRCP URL": "URL for unredacted metadata",
        "Unredacted Transcript URL": "URL for the non-redacted users response metadata",
        "DNIS": "The DNIS the customer called",
        "Matched Partial": "Indication whether partials were detected and used by the ASR engine to transcribe user response",
        "Original Transcription": "Original transcribed response before regex and partials we used to help better predict user response",
        "Partials": "List of partials detected when user response was transcribed by the ASR engine. Value is empty if no partials are detected",
        "Partials Processed": "Number of detected partials used by the VIVR engine to better predict user intents",
        "Data Center": "Data center where conversation is occurring",
        "ASR Engine": "ASR engine used to transcribe user response",
        "Entity Names": "Entities extracted from the caller's response",
        "Entity Values": "Values of each entity extracted from the caller's response",
        "Raw Phrases": "Portion of the caller's response being derived as an entity",
        "Entity Confidences": "Confidence in each each predicted entity extracted from caller's response"

    }
};
export const PROMPT_HANGUP = {
    id: "disconnect",
    title: "Disconnect",
    columns: {
        "Description": "The Prompt Disconnect report shows metrics on prompts where users disconnected from the Intelligent Assistant without providing input.", 
        "Prompt Name": "Name of the prompt sent by the Intelligent Assistant that the user response is associated with",
        "Prompt Group": "Group to which the prompt has been assigned",
        "Channel Rate": "The percentage of disconnects for the prompt name",
        "Channel Count": "The count of disconnects for the prompt name",
        "Overall Disconnect Rate": " How often a user disconnected without providing input following the associated prompt. This is calculated by taking events where the user disconnects without providing input from the Intelligent Assistant when presented with the prompt and dividing it by the total occurrences of the prompt in all conversations",
        "Overall Disconnect Count": "The total count of user disconnects without providing input following the associated prompt"
    }
};
export const SPEECH_RECOGNITION = {
    id: "asrAverageConfidence",
    title: "ASR Average Confidence",
    columns: {
        "Prompt Name": "Name of the prompt sent by the Intelligent Assistant that the user response is associated with",
        "Prompt Text": "Message from the Intelligent Assistant that the user response is associated with.",
        "Average Recognized Confidence": "Percentage of all transcribed audio responses that meet the ASR confidence threshold and were handled without error from the VIVR.",
        "Min Recognized Confidence": "Minimum recognized confidence rate.",
        "Max Recognized Confidence": "Maximum recognized confidence rate.",
        "Average Unrecognized Confidence": "Percentage of all transcribed audio responses that do not meet the ASR confidence threshold and failed to be handle by the VIVR.",
        "Min Unrecognized Confidence": "Minimum unrecognized confidence rate.",
        "Max Unrecognized Confidence": "Maximum unrecognized confidence rate."
    }
};
export const PROMPT_OUTCOME = {
    id: "promptOutcome",
    title: "Prompt Outcome",
    columns: {
        "Prompt Name": "Name of the prompt sent by the Intelligent Assistant that the user response is associated with",
        "Prompt Text": "Message from the Intelligent Assistant that the user response is associated with",
        "Prompt Group": "Group to which the prompt has been assigned",
        "Total Occurrences": "Total user responses",
        "Valid": "Number of user responses that either met the ASR and NLU confidence threshold or produced a valid speech recognition result",
        "Invalid ASR": "Number of user responses that did not meet the ASR confidence threshold",
        "Invalid NLU": "Number of user responses that did not meet the NLU confidence threshold",
        "No Input": "Total user responses with no audio input recorded",
        "Disconnect": "Total occurrences of users disconnecting rather than providing input",
        "Success Rate": "Overall percentage of user responses that met the ASR and NLU confidence threshold or produced a valid speech recognition grammar result"
    }
};
export const GRAMMAR_RESPONSES = {
    id: "grammarResponses",
    title: "Caller Utterance Report - Grammar",
    columns: {
        "Prompt Name": "Name of the prompt sent by the Intelligent Assistant that the user response is associated with",
        "Prompt Text": "Message from the Intelligent Assistant that the user response is associated with.",
        "Dialog Group": "Group to which the prompt has been assigned",
        "Grammar Files": "Grammar files used to evaluate and match user utterances",
        "User Response": "User input value associated with the selected Intelligent Assistant prompt",
        "Confidence": "How confident the Intelligent Assistant was in regards to transcribing the user's audio input (audio channels only)",
        "Raw Text": "Initial response transcribed by ASR engine before interpretation",
        "Valid Response": "True/False value indicating whether the user input matched a value in a grammar file that's a valid response to the VIVR prompt",
        "Error": "Type of error that occurred. Value is blank if valid",
        "Grammar Slot": "Slot value matched in grammar file",
        "Grammar File Used": "Grammar file used to match user input",
        "Input Mode": "Type of user response",
        "Channel": "The channel from which the user input was received",
        "Conversation Id": "Id referencing full conversation",
        "Timestamp": "Time prompt occurred",
        "Audio": "Redacted recording of user response if it exists",
        "Unredacted Audio URL": "URL for the non-redacted recording version of the users response",
        "Unredacted MRCP URL": "URL for unredacted metadata",
        "UCMA Audio": "Redacted recording of user response in ucma format if it exists",
        "Unredacted UCMA Audio": "URL for Unredacted recording of user response in ucma format if it exists",
        "DNIS": "The DNIS the customer called",
        "Data Center": "Data center where conversation is occurring",
        "Entity Names": "Entities extracted from the caller's response",
        "Entity Values": "Values of each entity extracted from the caller's response",
        "Raw Phrases": "Portion of the caller's response being derived as an entity",
        "Entity Confidences": "Confidence in each each predicted entity extracted from caller's response"
    }
};
export const SUCCESS = {
    id: "successReport",
    title: "Success Report",
    columns: {
        "Activity": "Specific transaction carried out between customers and the VIVR",
        "Success": "Number of successful transactions that occurred",
        "Total": "Total activity events started between users and the chabot",
        "Percentage": "Percentage of successful transactions carried out by the VIVR"
    }
}
export const ACTIVITY_SANKEY = { id: "activitySankey", title: "Activity Sankey" }
export const ACTIVITY_END_STATS = { id: "activityEndStats", title: "Activity End Report" }
export const INTENT_RESPONSES = {
    id: "intentResponses",
    title: "Intent Responses Report",
    columns: {
        "Prompt Name": "Name of the prompt sent by the Intelligent Assistant that the user response is associated with",
        "Dialog Group": "Group to which the prompt has been assigned",
        "Prompt Text": "Message from the Intelligent Assistant that the user response is associated with.",
        "User Response": "User input value associated with the selected Intelligent Assistant prompt",
        "Intent": "User's intent predicted by Intelligent Assistant if a prediction was generated",
        "Valid Response": "True/False value indicating whether the user input matched a trained Intent or user input resulted in a valid speech recognition grammar result",
        "Error": "Type of error that occurred. Value is blank if valid",
        "Intent Confidence": "How confident the Intelligent Assistant was in regards to matching the user input to a trained Intent",
        "ASR Confidence": "How confident the Intelligent Assistant was in regards to transcribing the user's audio input (audio channels only)",
        "Channel": "The channel from which the user input was received",
        "Conversation Id": "Id referencing full conversation",
        "Timestamp": "Time prompt occurred",
        "Input Mode": "Type of user response",
        "Audio": "Redacted recording of user response if it exists",
        "Unredacted Audio URL": "URL for the non-redacted recording version of the users response",
        "Unredacted MRCP URL": "URL for unredacted metadata",
        "Unredacted Transcript URL": "URL for the non-redacted users response metadata",
        "DNIS": "The DNIS the customer called",
        "Matched Partial": "Indication whether partials were detected and used by the ASR engine to transcribe user response",
        "Original Transcription": "Original transcribed response before regex and partials we used to help better predict user response",
        "Partials": "List of partials detected when user response was transcribed by the ASR engine. Value is empty if no partials are detected",
        "Partials Processed": "Number of detected partials used by the VIVR engine to better predict user intents",
        "Data Center": "Data center where conversation is occurring",
        "ASR Engine": "ASR engine used to transcribe user response"
    }
};
